<section class="hero" [ngStyle]="{ 'background-image': 'url(' + hero.img + ')' }" role="banner">
  <div class="overlay"></div>

  <div class="container">
    <div class="content">
      <section class="bg-blured">
        <h1>{{ hero.title | translate }}</h1>
        <p>{{ hero.description | translate }}</p>
      </section>

      <div class="actions">
        <a href="javascript:void(0)" (click)="scrollToSection(hero.learnMoreUrl)" class="btn btn-secondary"
          [matTooltip]="hero.learnMoreText | translate">
          {{hero.learnMoreText | translate}}
        </a>

        <a [href]="hero.contactUrl" class="btn btn-primary" [matTooltip]="hero.contactText | translate">
          {{hero.contactText | translate }}
        </a>
      </div>
    </div>
  </div>
</section>
